import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function isGoogleTagManagerLoaded(): boolean {
    return (
        !!document.querySelector('script[src*="googletagmanager.com/gtm.js"]') ||
        typeof window.google_tag_manager !== 'undefined'
    );
}

function loadGoogleTagManager(gtmId: string): void {
    if (!gtmId || isGoogleTagManagerLoaded()) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        'event': 'gtm.js',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    if (!document.getElementById('gtm-noscript-iframe')) {
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.id = 'gtm-noscript-iframe';
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.appendChild(noscript);
    }
}

if (environment.production) {
    enableProdMode();
}

loadGoogleTagManager(environment.googleTagManagerId);

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
